export default __webpack_public_path__ + "static/media/cucumbers.cd5103b8.jpg";